import { Injectable, Injector } from '@angular/core';
import { HttpClientService } from '../http-client-service';
import { of } from 'rxjs';
import {ApplicationConstants} from '../../../../../constants/application.constants';
import {isNullOrUndefined, isStringNullUndefinedOrEmptyWithTrim} from '../../../../../utility';
import {ClaimOverviewSearchRequest} from '../../../../../../models/ClaimOverviewSearchRequest';
import {catchError, map} from 'rxjs/operators';
import {ClaimSummaries, ClaimSummaryError} from '../../../../../../models/claimSummary';

@Injectable({
  providedIn: 'root'
})
export class ClaimOverviewDataService extends HttpClientService {
  constructor(protected injector: Injector) {
    super(injector, ApplicationConstants.dataServiceClientIDs.supplierWebDataService);
  }

  private getClaimOverviewApiEndpoint(): string {
    const claimOverviewApi = ApplicationConstants.api.claimSummaryApi;
    const domain = (!isStringNullUndefinedOrEmptyWithTrim(this.environment.claimSummaryUrl)) ? this.environment.claimSummaryUrl : this.environment.apiUrl;
    return `${domain}/${claimOverviewApi}/summary`;
  }

  searchClaimOverviews(claimOverviewSearchRequest: ClaimOverviewSearchRequest, statusCode: string) {
    const endpoint: string = this.getClaimOverviewApiEndpoint();
    return this.http.post(
      `${endpoint}/${statusCode}`,
      claimOverviewSearchRequest,
      {
        headers:
          {
            'Accept': 'application/json'
          }
      }).pipe(map((claimSummaries: ClaimSummaries) => {
        return claimSummaries;
      }),
      catchError((error: any) => {
        this.handleError('searchClaimOverviews', error);
        this.messageService.showErrorSnackbar(`${this.buildClaimSummaryErrorMessage(error)}`);
        return of(undefined);
      }));
  }

  buildClaimSummaryErrorMessage(error: any): string {
    // Set the default error message just in case.
    let errorMessage = ApplicationConstants.errorMessages.genericApiFailMessage;
    if (!isNullOrUndefined(error) && !isNullOrUndefined(error.error)) {
      const claimOverviewError: ClaimSummaryError = error.error;
      if (!isStringNullUndefinedOrEmptyWithTrim(claimOverviewError.errorMessage) && !isStringNullUndefinedOrEmptyWithTrim(claimOverviewError.errorId)) {
        if (claimOverviewError.errorId.toLowerCase() === 'pcsa0002') {
          errorMessage = ApplicationConstants.errorMessages.timeoutErrorMessage;
        } else {
          errorMessage = claimOverviewError.errorId + ' : ' + claimOverviewError.errorMessage;
        }
      }
    }
    return errorMessage;
  }
}
